module.exports = __webpack_public_path__ + "img/GaLoginImgNew.be58b9a1.svg";